<div
  class="cap-rec-popup-body"
  style="display: flex;
    flex-direction: column;"
>
  <ng-container *ngIf="showOpenRequestMessage && isEditAccess">
    <p class="note-margin">
      There is an open request for this capability. Therefore a new request cannot be created. Click
      <a class="link-click" style="cursor: pointer" (click)="navigateToOpenRequestPage()"> here </a>
      to view the request details.
    </p>
  </ng-container>
  <div class="d-flex justify-content-start" *ngIf="orgTab">
    <button
      mat-mdc-raised-button
      (click)="onBack(); $event.stopPropagation()"
      class="float-end m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-Margin"
    >
      Back
    </button>
  </div>
  <div class="d-flex justify-content-end" *ngIf="!orgTab">
    <button
      mat-mdc-raised-button
      (click)="onNonRecommended(); $event.stopPropagation()"
      class="float-end m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-Margin"
    >
      Choose capabilities not recommended by AI
    </button>
  </div>

  <ng-container *ngIf="!orgTab || selectedDataSource.data.length > 0">
    <mat-accordion style="margin-bottom: 1.5rem;">
      <mat-expansion-panel
        [expanded]="recCapabilitiesExpanded"
        #panel1
        [hideToggle]="true"
        (opened)="recCapabilitiesExpanded = true"
        (closed)="recCapabilitiesExpanded = false"
      >
        <mat-expansion-panel-header
          class="prevent-click expansion-Header-Width suite-container"
          style="padding-left: 0.01% !important; padding-right: 0px !important;border-radius: 0px;"
        >
          <mat-panel-title class="matPanelTitle" style="width: 63%; min-width: 70%;">
            <div class="pointer-event-auto" (click)="panel1.toggle(); $event.stopPropagation()">
              <span
                class="uitk-icon uitk-icon-arrow_right expansion-sm-icon"
                style="cursor: pointer;color: white;"
                *ngIf="!recCapabilitiesExpanded"
              ></span>
              <span
                class="uitk-icon uitk-icon-arrow_down expansion-sm-icon"
                style="cursor: pointer;color: white;"
                *ngIf="recCapabilitiesExpanded"
              ></span>
            </div>
            <div class="row m-0 ui-titlebar">
              <div class="recommended-header">AI-Recommended Capabilities</div>
            </div>
          </mat-panel-title>
          <mat-panel-description style="margin-right: 0%; flex-direction:row-reverse;"> </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="cap-rec-table-scroll">
          <!-- Selection view -->
          <app-editable-table
            [hidden]="isSelectedView"
            #editableTableComponent
            [SelectAll]="true"
            [isEditAccess]="true"
            [Popupp]="false"
            [manageSelectionModel]="true"
            [columns]="columns"
            [editSchemaConfig]="editSchemaConfig"
            (checkClick)="checkboxClick($event)"
            [dataSource]="dataSource"
            [tableConfig]="tableConfig"
            [totalCapabilities]="dataSource.data.length"
            (refreshOpenRequest)="refreshOpenRequestList($event)"
          >
          </app-editable-table>

          <!-- Selected items view with Actions column -->
          <app-editable-table
            #selectedEditableTable
            *ngIf="isSelectedView && selectedDataSource.data.length > 0"
            [SelectAll]="true"
            [isEditAccess]="true"
            [Popupp]="false"
            [manageSelectionModel]="true"
            [columns]="columns"
            [editSchemaConfig]="editSchemaConfig"
            [dataSource]="selectedDataSource"
            [tableConfig]="selectedTableConfig"
            [expandTemplate]="orgTemplate"
            (addOrgClick)="onAddOrganization($event)"
          >
          </app-editable-table>

          <ng-template #orgTemplate let-item>
            <app-cap-pop-up
              *ngIf="item.capPopUpVisible"
              #capPopUpRef
              [isEdit]="false"
              [showFormControls]="false"
              [showOrgTable]="true"
              [addOrgTrigger]="item._addOrgCount || 0"
              [application]="selectedApp"
              [mappedCapability]="[]"
              [excludeModel]="[]"
              [selectedCapOrgs]="[]"
              [capListForApp]="dataSource.data"
              [selectedCapRowData]="item"
              (orgSelected)="onOrgSelected(item)"
              (orgRemoved)="onOrgRemoved(item)"
              (dataReceived)="item.expand = false"
            >
            </app-cap-pop-up>
          </ng-template>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>
  <ng-container *ngIf="nonRecommendedCapabilities && (!orgTab || nonRecTableDataSource.data.length > 0)">
    <mat-accordion>
      <mat-expansion-panel
        [expanded]="nonRecCapabilitiesExpanded"
        #panel2
        [hideToggle]="true"
        (opened)="nonRecCapabilitiesExpanded = true"
        (closed)="nonRecCapabilitiesExpanded = false"
      >
        <mat-expansion-panel-header
          class="prevent-click expansion-Header-Width suite-container"
          style="padding-left: 0.01% !important; padding-right: 0px !important;border-radius: 0px;"
        >
          <mat-panel-title class="matPanelTitle" style="width: 63%; min-width: 70%;">
            <div class="pointer-event-auto" (click)="panel2.toggle(); $event.stopPropagation()">
              <span
                class="uitk-icon uitk-icon-arrow_right expansion-sm-icon"
                style="cursor: pointer;color: white;"
                *ngIf="!nonRecCapabilitiesExpanded"
              ></span>
              <span
                class="uitk-icon uitk-icon-arrow_down expansion-sm-icon"
                style="cursor: pointer;color: white;"
                *ngIf="nonRecCapabilitiesExpanded"
              ></span>
            </div>
            <div class="row m-0 ui-titlebar">
              <div class="recommended-header">Select capabilities not recommended by AI</div>
            </div>
          </mat-panel-title>
          <mat-panel-description style="margin-right: 0%; flex-direction:row-reverse;"> </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="cap-rec-table-scroll">
          <div class="d-flex justify-content-end" *ngIf="!orgTab">
            <button
              mat-mdc-raised-button
              (click)="onAddMoreCapabilities(); $event.stopPropagation()"
              [disabled]="!canAddMore"
              class="float-end m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-Margin"
            >
              Add More Capabilities
            </button>
          </div>

          <app-cap-pop-up
            [hidden]="orgTab"
            *ngFor="let row of nonRecRows; let i = index; trackBy: trackByIndex"
            [isEdit]="false"
            [showFormControls]="true"
            [showOrgTable]="false"
            [application]="selectedApp"
            [mappedCapability]="[]"
            [excludeModel]="[]"
            [selectedCapOrgs]="[]"
            [capListForApp]="combinedCapList"
            [extraMappedCapabilities]="extraMappedCapsPerRow[i] || []"
            [selectedCapRowData]="row"
            [getDisabledTooltip]="getDisabledTooltipFn"
            [openCapProposalWQReqArr]="openRequestCapabilities"
            [hideInternalMessage]="true"
            (capabilitySelected)="onRowCapabilitySelected(i, $event)"
          >
          </app-cap-pop-up>

          <!-- <ng-template #orgTemplate let-item>
            <app-cap-pop-up
              *ngIf="item.capPopUpVisible"
              #capPopUpRef
              [isEdit]="false"
              [showFormControls]="false"
              [addOrgTrigger]="item._addOrgCount || 0"
              [application]="selectedApp"
              [modelData]="modelData"
              [mappedCapability]="[]"
              [excludeModel]="[]"
              [selectedCapOrgs]="[]"
              [capListForApp]="dataSource.data"
              [selectedCapRowData]="item"
              (orgSelected)="onOrgSelected(item)"
              (orgRemoved)="onOrgRemoved(item)"
              (dataReceived)="item.expand = false">
            </app-cap-pop-up>
          </ng-template> -->
            <!-- Non-recommended selected view table -->
  <ng-container *ngIf="isSelectedView && nonRecTableDataSource.data.length > 0">
    <app-editable-table
      #nonRecSelectedEditableTable
      [SelectAll]="true"
      [isEditAccess]="true"
      [Popupp]="false"
      [manageSelectionModel]="true"
      [columns]="nonRecTableColumns"
      [editSchemaConfig]="nonRecEditSchemaConfig"
      [dataSource]="nonRecTableDataSource"
      [tableConfig]="nonRecTableConfig"
      [expandTemplate]="nonRecOrgTemplate"
      (checkClick)="nonRecCheckboxClick($event)"
      (addOrgClick)="onAddOrganization($event)"
    >
    </app-editable-table>
    <ng-template #nonRecOrgTemplate let-item>
      <app-cap-pop-up
        *ngIf="item.capPopUpVisible"
        [isEdit]="false"
        [showFormControls]="false"
        [showOrgTable]="true"
        [addOrgTrigger]="item._addOrgCount || 0"
        [application]="selectedApp"
        [mappedCapability]="[]"
        [excludeModel]="[]"
        [selectedCapOrgs]="[]"
        [capListForApp]="dataSource.data"
        [selectedCapRowData]="item"
        (orgSelected)="onOrgSelected(item)"
        (orgRemoved)="onOrgRemoved(item)"
        (dataReceived)="item.expand = false"
      >
      </app-cap-pop-up>
    </ng-template>
  </ng-container>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </ng-container>

  <div style="margin-top: 16px;">
    <button
      *ngIf="!isSelectedView"
      mat-mdc-raised-button
      (click)="onCapabilitySelected(); $event.stopPropagation()"
      [disabled]="!canContinue"
      [matTooltip]="continueDisabledTooltip"
      [matTooltipDisabled]="canContinue"
      class="btn-continue float-end m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-Margin"
    >
      Continue
    </button>
  </div>
  <div>
    <button
      *ngIf="isSelectedView && !hideApplyButton"
      mat-mdc-raised-button
      (click)="onApply(); $event.stopPropagation()"
      [disabled]="!selectedOrgData || checkedCapabilitiesCount === 0"
      class="float-end m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-Margin"
    >
      Apply
    </button>
  </div>
  <app-modal [maximizable]="true" [inViewport]="true" #applyPopup class="attestation-popup">
    <ng-container class="app-modal-body">
      <div style="display: flex;flex-direction: column;align-items: center;gap: 1rem;">
        <span>Capabilities added - {{ checkedCapabilitiesCount }}</span>
        <span>Organization(s) added - {{ selectedOrgCount }}</span>
      </div>
      <div
        *ngIf="_nonRecSelectedEditableTable?.selection?.selected?.length > 0"
        class="d-flex flex-column"
        style="gap: 1rem;"
      >
        <span style="color: #013B71; font-weight: 600; font-size: 14px;">
          One or more capabilities selected is not part of AI recommendations.</span>
          <span>Please share your feedback 
            <span class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span>
        </span>
        <textarea [(ngModel)]="nonRecFeedback" style="width: 100%; height: 100px; resize: vertical;" placeholder="Enter your feedback here..."></textarea>
      </div>
      <div class="d-flex attestation-button m-1">
        <button
          (click)="onCancel()"
          class="add-apply pull-right m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size me-2"
        >
          Cancel
        </button>
        <button
          (click)="onSubmit()"
          [disabled]="_nonRecSelectedEditableTable?.selection?.selected?.length > 0 && !nonRecFeedback?.trim()"
          class="add-apply pull-right m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
        >
          Continue
        </button>
      </div>
    </ng-container>
  </app-modal>
</div>
